module.exports = __webpack_public_path__ + "static/media/invideo_ai.d20b178d.png";